import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'

import Icon from './Icon'

// NOTE: Can only be used as a controlled checkbox.
// (i.e. this component does not create the local state required for a uncontrolled solution;
// you have to create it yourself)
function Checkbox ({ checked, name, label, disabled, extraClass, onChange }) {
  return (
    <div
      className={classnames(
        extraClass && extraClass,
        'checkbox relative flex items-center'
      )}
    >
      <input
        className='checkbox__input absolute top-0 left-0 right-0 bottom-0'
        type='checkbox'
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        onKeyPress={e => {
          // ENTER
          if (e.charCode === 13) {
            onChange()
          }
        }}
      />
      <div className='checkbox__ui'>{checked && <Icon icon='checkmark' />}</div>
      <label htmlFor={name}>{label}</label>
    </div>
  )
}

Checkbox.propTypes = {
  extraClass: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onChange: PropTypes.func.isRequired
}

Checkbox.defaultProps = {
  onChange: () => {}
}

export default Checkbox



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/Checkbox.js